<template>
    <v-app id="inspire">
        <v-navigation-drawer 
            v-model="drawer"
            color="#FFFFFF"
            app
            >
            <Navigation></Navigation>
        </v-navigation-drawer>
        <v-app-bar 
          app
          color="#004236"
        >
          <v-app-bar-nav-icon @click="drawer = !drawer" color="white"></v-app-bar-nav-icon>
          <v-toolbar-title>
            <span>SFS Student Portal</span>
          </v-toolbar-title>
        </v-app-bar>

        <v-main>
            <router-view>
            </router-view>
        </v-main>

        <MobileNavigation id="mobileNav" v-if="mobile" />
    </v-app>
</template>
  
  <script>
  import Navigation from '../../../components/Student/Navigation/Navigation.vue'
  import MobileNavigation from '../../../components/Student/Navigation/MobileNav.vue'
  
  export default {
    name: 'StudentApp',
    components: {
      Navigation,
      MobileNavigation
    },
    data(){
      return {
        drawer: null,
        mobile: false,
        mobileWidthMax: 760
      }
    },
    methods: {
      onResize() {
        const that = this;
        window.addEventListener("resize", () => {
          that.detectUX();
        });
      },
      detectUX() {                
        const that = this;
        that.mobile = window.innerWidth <= that.mobileWidthMax ? true : false;
      } 
    },
    mounted() {      
      this.detectUX();
      this.onResize();      
    }
  }
  </script>
  
  <style scoped>
  span{
    color: white;
  }
  #mobileNav{
    position: sticky;
    bottom: 5px;
  }
  </style>